import React, { useEffect, useState, useCallback } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { debounce, isEmpty } from 'lodash';

import moment from 'moment';

import { array } from 'prop-types';

import { Grid, GridColumn as Column, getSelectedState } from '@progress/kendo-react-grid';

import { getter } from '@progress/kendo-react-common';
import SearchInput from '../../Global/SearchInput';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import TotalsPanel from '../../../components/TotalsPanel';
import BobActionMenu from '../../../components/BobActionMenu';
import BobModal from '../../../components/BobModal';
import BobServiceManagementFilter from '../../../components/BobServiceManagementFilter';
import ServiceRequestActionModal from './ServiceRequestActionModal';
import CreateServiceRequestModal from './CreateServiceRequestModal';
import BobLoadingMask from '../../../components/BobLoadingMask';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';

import * as BobActions from '../../../actions/bobActions';
import * as jobActions from '../../../actions/jobActions';

import classes from './Table.module.css';

const idGetter = getter('id');

const ServiceRequestList = ({
    bobLoading,
    createServiceRequest,
    history,
    isActive,
    isFromEntityOverviewpage,
    fetchServiceRequestList,
    fetchServiceManagementLookups,
    handleToggleCreateServiceRequest,
    handleToggleServiceRequestActionModal,
    serviceRequestActionModalOpen,
    serviceRequests,
    serviceRequestsMeta,
    activeNavCompany,
    ...props
}) => {
    const [serviceItemList, setServiceItemList] = useState([]);
    const [selectedServiceRequest, setSelectedServiceRequest] = useState([]);
    const [actionType, setActionType] = useState(null);

    const [sort, setSort] = useState([]);
    const [sortFilter, setSortFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    
    const [selectedState, setSelectedState] = useState({});

    useEffect(() => {
        setSearchTerm();
        setSort([]);
        setSkip(0);
        setTake(10);
    }, []);

    useEffect(() => {
        async function init() {
            await Promise.all([
                fetchServiceRequestList(activeNavCompany.id, { sort: '', searchFilter: searchTerm, page: 1, limit: take }),
                fetchServiceManagementLookups(activeNavCompany.id, 'Jobissuetype'),
                fetchServiceManagementLookups(activeNavCompany.id, 'Skilllevel'),
                fetchServiceManagementLookups(activeNavCompany.id, 'Skilltype')
            ].map(p => p.catch(err => err)));
        }

        if (activeNavCompany && activeNavCompany.id) init();
    }, [activeNavCompany]);
    
    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey:   'id',
        });

        setSelectedState(newSelectedState);
    };

    const onHeaderSelectionChange = useCallback((event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        let selectedStateItems = {};

        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
            if (checked) {
                selectedStateItems[idGetter(item)] = item;
            }

        });
        if (!checked) {
            selectedStateItems = {};
        }
        setSelectedState(newSelectedState);
    }, []);

    const fetchServiceRequestListAfterCreate = () => {
        handleToggleCreateServiceRequest(false);
        
        fetchServiceRequestList(activeNavCompany.id, { sort: '', searchFilter: searchTerm, page: 1, limit: take });
    };

    useEffect(() => {
        setServiceItemList(serviceRequests);
    }, [serviceRequests]);

    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);

        setSkip(0);

        if (sortFilter) {
            await fetchServiceRequestList(activeNavCompany.id, { sort: sortFilter, searchFilter: searchTerm, page: 1, limit: take });
        } else {
            await fetchServiceRequestList(activeNavCompany.id, { sort: '', searchFilter: searchTerm, page: 1, limit: take });
        }
    };

    const handlePageChange = async event => {
        setSkip(event.page.skip);
        setTake(event.page.take);

        let page = 1;

        if (event.page.skip > 0) {
            page = event.page.skip / event.page.take + 1;
        }

        if (sortFilter) {
            await fetchServiceRequestList(activeNavCompany.id, { sort: sortFilter, searchFilter: searchTerm, page: page, limit: event.page.take });
        } else {
            await fetchServiceRequestList(activeNavCompany.id, { sort: '', searchFilter: searchTerm, page: page, limit: event.page.take });
        }
    };

    const fetchRequestData = (requestData, actionType) => {
        setSelectedServiceRequest([requestData]);
        setActionType(actionType);
        handleToggleServiceRequestActionModal(true);
    };

    const actionsCell = props => {
        return (
            <td>
                <BobTableContextMenu 
                    type="ServiceManagement"
                    entityData={props.dataItem}
                    onFetch={(requestData, actionType) => fetchRequestData(requestData, actionType)}
                />
            </td>
        );
    };
    
    const createdOnCell = props => {
        return (
            <td>{moment(props.dataItem[props.field]).format('YYYY-MM-DD')}</td>
        );
    };

    const handleSort = async event => {
        // let page = 1;

        if (skip > 0) {
            // page = skip / take + 1;
        }

        setSort(event.sort);

        let sort;

        if (event.sort[0]) {
            sort = event.sort[0].field + '^' + event.sort[0].dir;
            setSortFilter(sort);
        } else {
            setSortFilter('');
        }

        if (sort) {
            //
        } else {
            //
        }
    };

    const nameCell = props => {
        return (
            <td>
                <div>
                    {props.dataItem[props.field]}
                </div>
            </td>
        );
    };

    const issueTypeCell = props => {
        const issueTypes = props.dataItem[props.field];
        let issueTypeNames = '';

        if (!isEmpty(issueTypes)) {
            issueTypeNames = issueTypes.map(item => item.name).join(', ');
        }

        return (
            <td>
                <div>
                    <Link to={'#'}>
                        {issueTypeNames}
                    </Link>
                </div>
            </td>
        );
    };

    if (!isActive && isFromEntityOverviewpage) return null;
    
    return (
        <div className={classes.Table}>
            <div className={classes.TableContainerHead}>
                <div className={classes.SearchContainer}>
                    <SearchInput
                        className={classes.SearchInput}
                        search={debounce(handleSearch, 700)}
                        placeholder="Search by Service Request ID"
                        value={searchTerm}
                    />
                </div>
                <div className={classes.TotalsContainer}>
                    <TotalsPanel
                        data={{}}
                        entityType={'ServiceManagement'}
                    />
                </div>
                <div className={classes.FilterContainer}>
                    <BobServiceManagementFilter />
                </div>
                <div className={classes.ActionButtonContainer}>
                    <BobActionMenu 
                        type={'ServiceManagement'}
                        handleCreateServiceRequest={() => handleToggleCreateServiceRequest(true)}
                    />
                </div>
            </div>
            <Grid
                sortable
                sort={sort}
                onSortChange={(e) => {
                    handleSort(e);
                }}
                className={classes.KendoGrid}
                data={serviceItemList.map( item => ({
                    ...item,
                    'selected': selectedState[idGetter(item)],
                }))}
                take={take}
                skip={skip}
                total={serviceRequestsMeta && serviceRequestsMeta.totalCount ? serviceRequestsMeta.totalCount : 0 }
                onPageChange={handlePageChange}
                pageable={pageable}
                reorderable
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                dataItemKey={'id'}
                selectedField={'selected'}
                selectable={{
                    enabled: true,
                    drag:    false,
                    cell:    false,
                    mode:    'multiple',
                }}
            >
                <Column
                    field="selected"
                    width="70px"
                    headerSelectionValue={
                        serviceItemList.length > 0 && serviceItemList.findIndex((item) => !selectedState[idGetter(item)]) === -1
                    }
                    filterable={false}
                    sortable={false}
                />
                <Column
                    field={'description'}
                    title={dashboardContent.name}
                    width="220px"
                    cell={nameCell}
                />
                <Column field={'relatedClient.name'} title={dashboardContent.client} width="auto" />
                <Column field={'relatedSite.name'} title={dashboardContent.site} width="auto" />
                <Column field={'priority'} title={dashboardContent.priority} width="auto" />
                <Column field="target" title={dashboardContent.target} width="auto" />
                <Column
                    field={'jobIssueTypes'}
                    title={dashboardContent.issueType}
                    width="auto"
                    cell={issueTypeCell}
                />
                <Column
                    field={'insertTimestamp'}
                    title={dashboardContent.createdOn}
                    width="auto"
                    cell={createdOnCell}
                />
                <Column field={'summary'} title={dashboardContent.summary} width="200" />
                <Column field={'jobStatus'} title={dashboardContent.status} width="auto" />
                <Column
                    field=""
                    title=""
                    width="auto"
                    cell={actionsCell}
                />
            </Grid>
            {
                createServiceRequest ? 
                    <BobModal
                        title={'New Service Request'}
                        hidebuttons={true}
                        isRemoveFooter={true}
                        onClose={() => {
                            handleToggleCreateServiceRequest(false);}}
                    >
                        <CreateServiceRequestModal
                            isFromEntityOverviewpage={isFromEntityOverviewpage}
                            fetchServiceRequestListAfterCreate={fetchServiceRequestListAfterCreate}
                            onClose={() => {
                                handleToggleCreateServiceRequest(false);}}
                        />
                    </BobModal> : '' 
            }
            {
                serviceRequestActionModalOpen ? 
                    <BobModal
                        title={'Service Request'}
                        hidebuttons={true}
                        isRemoveFooter={true}
                        onClose={() => { 
                            setSelectedServiceRequest([]); 
                            setActionType(null);
                            handleToggleServiceRequestActionModal(false);}}
                    >
                        <ServiceRequestActionModal
                            selectedServiceRequest={selectedServiceRequest}
                            actionType={actionType}
                            onClose={() => {
                                setSelectedServiceRequest([]); 
                                setActionType(null);
                                handleToggleServiceRequestActionModal(false);}}
                        />
                    </BobModal> : '' 
            }
            {
                bobLoading.includes('ServiceRequestData') || bobLoading.includes('Skilllevel') || bobLoading.includes('Skilltype') || bobLoading.includes('issue') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

ServiceRequestList.defaultProps = {
    serviceRequests: []
};

ServiceRequestList.propTypes = {
    serviceRequests: array
};

const mapStateToProps = state => ({
    bobLoading:          state.bob.bobLoading,
    serviceRequests:     state.job.serviceRequests,
    serviceRequestsMeta: state.job.serviceRequestsMeta,
    activeNavCompany:    state.bob.activeNavCompany
});

const mapDispatchToProps = ({
    ...BobActions,
    ...jobActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ServiceRequestList));
